module.exports = __webpack_public_path__ + "img/1725845265055-WhatsApp Image 2024-08-14 at 09.41.22 1.jpeg.335dcd60.webp";